import { InstallmentNumber, IProductDataState } from "../../app/store/product/productOverview/types";

export default class ProductData implements IProductDataState {

  tariff: number;
  color: number;
  contract: InstallmentNumber;
  cosmosInstallments: number;
  participation: number;
  cosmosModel: string | string[];
  paymentType: string;
  purchase: string | string[];
  contractType: string;
  installments: boolean;
  type: string;
  productId: number;
  isFilterEnable: boolean;

  constructor(
    tariff: number,
    color: number,
    contract: InstallmentNumber,
    cosmosInstallments: number,
    participation: number,
    cosmosModel: string | string[],
    paymentType: string,
    purchase: string | string[],
    contractType: string,
    installments: boolean,
    type: string,
    productId: number,
    isFilterEnable: boolean
  ) {
    this.tariff = tariff;
    this.color = color;
    this.contract = contract;
    this.cosmosInstallments = cosmosInstallments;
    this.participation = participation;
    this.cosmosModel = cosmosModel;
    this.paymentType = paymentType;
    this.purchase = purchase;
    this.contractType = contractType;
    this.installments = installments;
    this.type = type;
    this.productId = productId;
    this.isFilterEnable = isFilterEnable;
  }

}
